import React from 'react';
import { Redirect } from 'react-router-dom';
import useUrlState from '../../../hooks/useUrlState';
import useWebsiteSetupStatus from '../hooks/useWebsiteSetupStatus';
import LoaderCard from '../../shared/LoaderCard';
import AddDomainStep from './AddDomainStep';
import SitemapImportProgress from './SitemapImportProgress';
import AddUrlsManuallyStep from './AddUrlsManuallyStep';
import './Wizard.less';

export default function AddWebsiteIndexEntryWizard() {
    const [urlState, setUrlState] = useUrlState();
    const { w_guid: websiteGuid } = urlState;

    const { websiteStatus, isLoadingWebsiteStatus, refetchWebsiteStatus } = useWebsiteSetupStatus(websiteGuid);

    const finishAddDomainStep = (websiteGuid: string) => {
        setUrlState({ w_guid: websiteGuid });
    };

    const finishAddUrlsManuallyStep = () => {
        refetchWebsiteStatus();
    };

    return (
        <>
            {isLoadingWebsiteStatus && <LoaderCard />}

            {!!websiteStatus && websiteStatus.status === 'importing_sitemaps' && (
                <SitemapImportProgress
                    sitemapUrls={websiteStatus.website.sitemap_urls || []}
                    sitemapStartTime={websiteStatus.import_sitemaps_started_at!}
                />
            )}

            {websiteGuid === undefined && (
                <AddDomainStep
                    loading={isLoadingWebsiteStatus}
                    onFinish={finishAddDomainStep}
                />
            )}

            {!!websiteStatus && websiteStatus.status === 'waiting_for_user_input' && (
                <AddUrlsManuallyStep
                    websiteGuid={websiteGuid}
                    loading={isLoadingWebsiteStatus}
                    onFinish={finishAddUrlsManuallyStep}
                />
            )}

            {!!websiteStatus && websiteStatus.status === 'completed' && <Redirect to={{ pathname: '/deep-analysis', search: `?w_guid=${websiteGuid}` }} />}
        </>
    );
}
